/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="96.08" height="85.22" viewBox="0 0 96.08 85.22" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M31.34,34.59A1.5,1.5,0,0,1,32.83,36v80.87h80.72a1.51,1.51,0,0,1,1.5,1.35v.15a1.49,1.49,0,0,1-1.35,1.49H31.34a1.5,1.5,0,0,1-1.49-1.36V36.09A1.5,1.5,0,0,1,31.34,34.59Z" transform="translate(-29.84 -34.59)" fill="#0e497b"/><path d="M123.36,43.48a1.5,1.5,0,0,1,2.23,2l-.1.11L88.15,83.11l-14-13.89L44.75,98.79a1.49,1.49,0,0,1-2,.11l-.12-.1a1.5,1.5,0,0,1-.1-2l.1-.11L74.18,65l14,13.89Z" transform="translate(-29.84 -34.59)" fill="#ffb81c"/>
</svg>

    );
  }
}

Icon.displayName = 'LineGraphUpwardsTrendIcon';

export default Icon;
